<template>
  <v-dialog width="500" v-model="dialog">
    <v-card>
      <div
        class="d-flex align-center"
        style="justify-content: space-between; padding: 0px 24px 0px 0px"
      >
        <v-card-title>{{ $t("edit") }}</v-card-title>
        <span @click="close" class="cursor-pointer">
          <vue-icon icon="newBoldCloseIcon"></vue-icon>
        </span>
      </div>
      <v-card-text>
        <v-list dense>
          <v-list-item class="pl-0">
            <v-list-item-title class="column-list">
              <span class="label">
                {{ $t("numberRequest") }}
              </span>
              <span class="value">
                {{ orderItem.numb }}
              </span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="pl-0">
            <v-list-item-title class="column-list">
              <span class="label">
                {{ $t("orderRequestItemNumber") }}
              </span>
              <span class="value">
                {{ orderItem.itemNumb }}
              </span>
            </v-list-item-title>
          </v-list-item>

          <v-list-item class="pl-0">
            <v-list-item-title class="column-list">
              <span class="label">
                {{ $t("state") }}
              </span>
              <span class="value">
                {{ $t(orderItem.state) }}
              </span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
        <custom-select
          v-model="selectedStatus"
          :label="$t('chooseAnotherStatus')"
          class="user_input no-margin"
          :items="orderItemStatus"
          item-text="text"
          item-value="value"
        ></custom-select>
        <div class="text-right mt-4">
          <v-btn
            @click="submit"
            width="100%"
            color="primary"
            :loading="loading"
            >{{ $t("save") }}</v-btn
          >
        </div>
      </v-card-text>
      <warning-dialog
        yes-text="yes"
        description="wantToContinue"
        v-model="warningDialog"
        @apply="changeState"
        ref="warningDialogRef"
      ></warning-dialog>
    </v-card>
  </v-dialog>
</template>

<script>
import { orderItemStatus } from "@/utils/constants.js";
import WarningDialog from "@/components/ui/prompt/warning-dialog.vue";

export default {
  name: "DivisionOrderItemChangeStatusDialog",
  components: { WarningDialog },
  emits: ["changed"],
  data() {
    return {
      warningDialog: false,
      dialog: false,
      loading: false,
      orderItem: {},
      selectedStatus: null,
    };
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.orderItem = {};
        this.loading = false;
        this.selectedStatus = null;
      }
    },
  },
  methods: {
    submit() {
      this.warningDialog = true;
    },
    async changeState() {
      this.loading = true;
      try {
        await this.$http.post("backend/order-item-change-state", {
          state: this.selectedStatus,
          id: this.orderItem.id,
        });
        this.$emit("changed");
        this.setSuccess({ text: this.$t("successfullySaved") });
        this.dialog = false;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
    /**
     * @typedef orderItem {Object}
     * @property numb {number}
     * @property itemNumb {number}
     * @property state {string}
     * @property id {number}
     * @param data {orderItem}
     */
    open(data) {
      this.dialog = true;
      this.orderItem = data;
      this.selectedStatus = data.state;
    },
    close() {
      this.dialog = false;
    },
  },
  computed: {
    orderItemStatus() {
      return Object.keys(orderItemStatus).map((item) => {
        return {
          text: this.$t(item),
          value: item,
        };
      });
    },
  },
};
</script>

<style scoped lang="scss">
.v-list-item__title.column-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 10px;
}

.v-list-item__title .label {
  color: #a2a5b9;
  font-size: 12px;
  font-weight: 400;
}

.v-list-item__title .value {
  color: #48545d;
  font-size: 16px;
  font-weight: 400;
}
</style>
